import React, { useEffect, useRef, useState } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import Topbar from "../../../components/Topbar/Topbar";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { Autocomplete, TextField, Chip, Box } from "@mui/material";
import { drag, dummyimage, edit_icon, Search_icon } from "../../../assets/img";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Loader from "../../../components/Loader";
import { checkPermission } from "../../redux/api/PermissionManager";

const HotelCategories = () => {
  const [addPopup, setAddPopup] = useState(false);
  const [errors, setErrors] = useState(false);
  const [hotelId, setHotelId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedService, setSelectedService] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [formData, setFormData] = useState({
    display_name: "",
    name: "",
    services: [],
    image: "",
  });
  const [serviceOptions, setServiceOptions] = useState([]);
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);

  const inputRef = useRef(null);
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  useEffect(() => {
    fetchServices();
    fetchCategories(page);
  }, [page, search]);

  useEffect(() => {
    if (hotelId) fetchDetails();
  }, [hotelId]);

  const fetchServices = async () => {
    try {
      const res = await get(`${URLS.SERVICESLIST}list`);
      const formatted = res?.data?.map((item) => ({
        label: item.display_name,
        value: item.id,
      }));
      setServiceOptions(formatted);
    } catch (err) {
      console.error("Error fetching services:", err);
    }
  };

  const fetchCategories = async (page = 1) => {
    const url = search
      ? `${URLS.HOTELCATEGORIES}?search=${search}`
      : `${URLS.HOTELCATEGORIES}?page=${page}`;

    try {
      const res = await get(url);
      setList(res?.results || res?.data || []);
      setTotalCount(res?.count);
      // Assuming API returns count and results
      const pageSize = 10;
      const lastPage = Math.ceil(res?.count / pageSize);

      setPagination({
        current_page: page,
        last_page: lastPage || 1,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDetails = async () => {
    try {
      const res = await get(`${URLS.HOTELCATEGORIES}${hotelId}/`);
      if (res?.data) {
        setFormData({
          display_name: res.data.display_name || "",
          name: res.data.name || "",
          services: res.data.services || [],
          image: res.data.image || "",
        });
        setSelectedImage(null);
        setSelectedService(
          res.data.services?.map((s) => ({
            label: s.name || s.display_name,
            value: s.id,
          })) || [],
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSort = () => {
    let items = [...list];
    const draggedItemContent = items.splice(dragItem.current, 1)[0];
    items.splice(dragOverItem.current, 0, draggedItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setList(items);
    setShow(true);
  };

  const savePosition = async () => {
    setLoading(true);
    try {
      const payload = list.map((item, index) => ({
        id: item.id,
        position: index + 1,
      }));

      const res = await post(`${URLS.HOTELCATEGORIES}positions/`, payload);

      if (res?.status === "success") {
        toast.success(res?.message || "Position updated");
        setShow(false);
        fetchCategories(page);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Failed to save positions");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!formData.display_name || !formData.name) {
      setErrors(true);
      return;
    }

    if (selectedService.length === 0) {
      toast.error("Please select one services");
      return;
    }

    try {
      setLoading(true);
      const data = new FormData();
      data.append("display_name", formData.display_name);
      data.append("name", formData.name);

      const arrayServices = selectedService.map((s) => s.value);

      console.log("arrayServices", arrayServices);

      // Send as JSON array
      data.append("services", JSON.stringify(arrayServices));

      if (selectedImage) data.append("image", selectedImage);

      const res = await post(`${URLS.HOTELCATEGORIES}${hotelId}/edit/`, data);
      if (res?.status === "success") {
        toast.success(res?.message || "Updated successfully");
        setAddPopup(false);
        fetchCategories(page);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      toast.error("Error updating category");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) setSelectedImage(file);
  };

  const handleImageClick = () => inputRef.current.click();

  return (
    <div>
      <Topbar header="Master" subHead="Hotel Categories" />

      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total:{totalCount || list?.length}
        </h2>
        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: 150 }}
              onChange={(e) => setSearch(e.target.value)}
            />
            <img src={Search_icon} className="search" alt="" />
          </div>
          {show && (
            <button
              onClick={savePosition}
              className="submit-btn f2"
              style={{ minWidth: 120 }}
            >
              Save
            </button>
          )}
        </div>
      </div>

      <div className="mt-5" style={{ width: "100%", overflow: "auto" }}>
        <table
          className="table-design-new"
          style={{ width: "98%", borderRadius: "10px" }}
        >
          <thead>
            <tr className="border-bottom w-100">
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                S.No
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Image
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Categories
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Service Type
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                User Status
              </th>
              <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                Status
              </th>
              {checkPermission("CAN-EDIT-HOTEL_CATEGORIES") && (
                <th className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3  p-2">
                  Action
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {list?.map((item, index) => (
              <tr
                key={index}
                className="list-item p-2"
                // draggable
                onDragStart={() => (dragItem.current = index)}
                onDragEnter={() => (dragOverItem.current = index)}
                onDragEnd={handleSort}
                onDragOver={(e) => e.preventDefault()}
              >
                <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 red list-data ">
                  {(page - 1) * 10 + index + 1}
                </td>
                <td>
                  <img
                    src={item.image || dummyimage}
                    className="list-img my-2"
                    alt=""
                  />
                </td>
                <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  {item.display_name}
                </td>
                <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  {item.services?.map((s, idx) => (
                    <p key={idx}>{s.name || s.display_name}</p>
                  ))}
                </td>
                <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  <button
                    onClick={() => {
                      if (checkPermission("CAN-STATUS-HOTEL_CATEGORIES")) {
                        post(
                          `${URLS.HOTELCATEGORIES}${item.id}/user-visible/`,
                          {
                            is_user_visible: !item.is_user_visible,
                          },
                        );
                        toast.success("Status updated Successfully");
                        setTimeout(() => {
                          fetchCategories(page);
                        }, 1000);
                      }
                    }}
                    className={
                      item.is_user_visible == true
                        ? "active-btn"
                        : "deactive-btn"
                    }
                  >
                    {item.is_user_visible == true ? "Active" : "De-active"}
                  </button>
                </td>
                <td className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data ">
                  <button
                    onClick={() => {
                      if (checkPermission("CAN-STATUS-HOTEL_CATEGORIES")) {
                        post(`${URLS.HOTELCATEGORIES}${item.id}/status/`, {
                          status: !item.status,
                        });
                        toast.success("Status updated Successfully");
                        setTimeout(() => {
                          fetchCategories(page);
                        }, 1000);
                      }
                    }}
                    className={
                      item.status == true ? "active-btn" : "deactive-btn"
                    }
                  >
                    {item.status == true ? "Active" : "De-active"}
                  </button>
                </td>
                {checkPermission("CAN-EDIT-HOTEL_CATEGORIES") && (
                  <td>
                    <button
                      onClick={() => {
                        setHotelId(item.id);
                        setAddPopup(true);
                      }}
                      className="cust-btn"
                    >
                      <img src={edit_icon} alt="" className="edit-btn" />
                    </button>
                  </td>
                )}
                <td className="position-relative">
                  <div className="drag-box">
                    <img src={drag} className="drag-img" alt="" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Edit Popup */}
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup w-60">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                Edit
              </p>
              <CloseSharpIcon
                onClick={() => setAddPopup(false)}
                className="pointer"
              />
            </div>

            <div className="w-100 mt-3 d-flex flex-wrap ac-ja gap-3">
              {/* Display Name */}
              <div className="w-40">
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15  text-start">
                  Display Name
                </p>
                <input
                  className="input-box"
                  name="display_name"
                  value={formData.display_name}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      display_name: e.target.value,
                    }))
                  }
                  type="text"
                  placeholder="Display Name"
                />
                {errors && !formData.display_name && (
                  <p className="err">Enter Display Name</p>
                )}
              </div>

              {/* Real Name */}
              <div className="w-40">
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15  text-start">
                  Real Name
                </p>
                <input
                  className="input-box"
                  name="name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, name: e.target.value }))
                  }
                  type="text"
                  placeholder="Real Name"
                  disabled
                />
                {errors && !formData.name && (
                  <p className="err">Enter Real Name</p>
                )}
              </div>

              {/* Service Type */}
              <div className="w-40">
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15  text-start">
                  Service Type
                </p>
                {/* <Autocomplete
                  multiple
                  options={serviceOptions}
                  getOptionLabel={(option) => option.label}
                  value={selectedService}
                  onChange={(event, newValue) => setSelectedService(newValue)}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option.value}
                        label={option.label}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Service" disabled />
                  )}
                  disabled // 👈 makes whole Autocomplete non-editable
                /> */}
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    padding: "6px 8px",
                    minHeight: "40px",
                    alignItems: "center",
                  }}
                >
                  {selectedService.length > 0 ? (
                    selectedService.map((option) => (
                      <Chip
                        key={option.value}
                        label={option.label}
                        size="small"
                        sx={{ pointerEvents: "none" }} // 👈 makes it non-clickable
                      />
                    ))
                  ) : (
                    <span style={{ color: "#888" }}>No service selected</span>
                  )}
                </Box>
              </div>

              {/* Image Upload */}
              <div className="w-40 ">
                <div className="d-flex ac-js">
                  <div
                    onClick={handleImageClick}
                    className="position-relative w-100"
                  >
                    <HighlightOffRoundedIcon className="img-cancel" />
                    <div>
                      <img
                        alt="preview"
                        style={{ width: 80, height: 70 }}
                        src={
                          selectedImage
                            ? URL.createObjectURL(selectedImage)
                            : formData.image
                              ? formData.image
                              : dummyimage
                        }
                      />
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        ref={inputRef}
                        onChange={handleImageChange}
                      />
                    </div>
                  </div>
                </div>
                <h4 style={{ fontSize: 12 }} className="err mt-2">
                  Max Upload Size : 5MB and Banner Size 1200x700*
                </h4>
              </div>
            </div>

            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => setAddPopup(false)}
                className="back-btn f2 w-40"
              >
                Cancel
              </button>
              <button onClick={handleUpdate} className="submit-btn f2 w-40">
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default HotelCategories;
